import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-ab-image-attachment',
  templateUrl: './ab-image-attachment.component.html',
  styleUrls: ['./ab-image-attachment.component.scss']
})
export class AbImageAttachmentComponent implements OnInit {

 @Input() element: any;
  constructor() { }

  ngOnInit(): void {
  }

}
